import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-promotion",
  "use": "icon-promotion-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-promotion\"><defs><style type=\"text/css\"></style></defs><path d=\"M853.333333 386.133333a145.706667 145.706667 0 0 1 0 287.061334V386.133333z m-42.666666 283.989334v260.608a42.666667 42.666667 0 0 1-61.610667 38.272L298.666667 746.069333V896a42.666667 42.666667 0 0 1-42.666667 42.666667H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667v-213.290667h-0.042667L85.333333 682.666667a42.666667 42.666667 0 0 1-42.666666-42.666667V384a42.666667 42.666667 0 0 1 42.666666-42.666667h85.973334l578.005333-282.026666a42.666667 42.666667 0 0 1 61.354667 38.4v572.416z m-512-19.584l426.666666 210.602666V166.016L298.666667 377.514667v273.066666zM128 426.666667v170.666666h85.333333v-170.666666H128z\" p-id=\"2184\" fill=\"#f4ea2a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/promotion.svg
// module id = HzCk
// module chunks = 132